import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

const EditCategory = () => {
  const [category, setCategory] = useState("");
  const navigate = useNavigate();
  const API_BASE_URL = process.env.REACT_APP_API_BASEURL;
  const { id } = useParams();

  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/category/${id}`)
      .then((response) => {
        console.log(response);
        setCategory(response.data?.data?.category);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [id]);

  const handleSubmit = (e) => {
    e.preventDefault();
    axios
      .put(
        `${API_BASE_URL}/admin/category/${id}`,
        {
          category: category,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      )
      .then((resp) => {
        alert("Category Updated Successfully!");
        setCategory("");
        navigate("/all-category");
      })
      .catch((err) => {
        alert("Error updating category.");
        console.log(err);
      });
  };

  const handleAddNewCategory = () => {
    navigate("/add-category");
  };

  const handleViewAllCategory = () => {
    navigate("/all-category");
  };

  return (
    <div id="add-department-inner-wrapper">
      <div className="superheader">
        <div className="departmetHeaderdiv">
          <h5>Category</h5>
          <div className="departmentdiv2">
            <button className="handlenewclass" onClick={handleAddNewCategory}>
              + Add New Category
            </button>
            <button className="allclasses" onClick={handleViewAllCategory}>
              All Category
            </button>
          </div>
        </div>

        <div className="form-school-container">
          <h4 className="department-detail">Add Category</h4>
          <form onSubmit={handleSubmit} className="department-detail-form">
            <div className="input-group">
              <div style={{ paddingBottom: "10px" }}>
                <label className="label">Category</label>
              </div>
              <input
                className="school-class-add-input-tag"
                type="text"
                value={category}
                onChange={(e) => setCategory(e.target.value)}
                placeholder="Enter Category Name"
                required
              />
            </div>

            <div className="form-school-btns">
              <button className="btn-s" type="submit">
                Update
              </button>
              <button
                className="btn-c"
                type="button"
                onClick={() => navigate(-1)}
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default EditCategory;
